/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import NotoSans from '../../../src/assets/fonts/NotoSans-VariableFont_wdth,wght.ttf';
import NotoSansArabic from '../../../src/assets/fonts/NotoSansArabic-VariableFont_wdth,wght.ttf';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Header from './answerKeys/Header';
// Lesson Templates
import IntroductionVideo from '../main/pages/instance/views/templates/lesson/IntroductionVideo';
import Objectives from '../main/pages/instance/views/templates/lesson/Objectives';
import SceneSetter from '../main/pages/instance/views/templates/lesson/SceneSetter';
import TerminologyReview from '../main/pages/instance/views/templates/lesson/TerminologyReview';
import Reading from '../main/pages/instance/views/templates/lesson/Reading';
import Listening from '../main/pages/instance/views/templates/lesson/Listening';
import MultipleChoice from '../main/pages/instance/views/templates/lesson/MultipleChoice';
import ConceptCategorizing from '../main/pages/instance/views/templates/lesson/ConceptCategorizing';
import ErrorIdentification from '../main/pages/instance/views/templates/lesson/ErrorIdentification';
import SummaryEvaluation from '../main/pages/instance/views/templates/lesson/SummaryEvaluation';
import LinguisticEvaluation from '../main/pages/instance/views/templates/lesson/LinguisticEvaluation';
import RegisterAnalysis from '../main/pages/instance/views/templates/lesson/RegisterAnalysis';
import LessonSummary from '../main/pages/instance/views/templates/lesson/LessonSummary';
import ModuleSummary from '../main/pages/instance/views/templates/lesson/ModuleSummary';
import Enrichment from '../main/pages/instance/views/templates/lesson/Enrichment';
// Practical Exercise Templates
import PETransition from '../main/pages/instance/views/templates/practicalexercise/PETransition';
import PEMissionSelection from '../main/pages/instance/views/templates/practicalexercise/PEMissionSelection';
import PEBrief from '../main/pages/instance/views/templates/practicalexercise/PEBrief';
import PEEnvironment from '../main/pages/instance/views/templates/practicalexercise/PEEnvironment';
import FPEEnvironmentHome from '../main/pages/instance/views/templates/practicalexercise/FPEEnvironmentHome';
import FPEEnvironmentPath from '../main/pages/instance/views/templates/practicalexercise/FPEEnvironmentPath';
import PEReading from '../main/pages/instance/views/templates/practicalexercise/PEReading';
import PEInteractiveListening from '../main/pages/instance/views/templates/practicalexercise/PEInteractiveListening';
import PEReferenceReading from '../main/pages/instance/views/templates/practicalexercise/PEReferenceReading';
import PEReferenceListening from '../main/pages/instance/views/templates/practicalexercise/PEReferenceListening';
import PEMultipleChoice from '../main/pages/instance/views/templates/practicalexercise/PEMultipleChoice';
import PEConceptComprehension from '../main/pages/instance/views/templates/practicalexercise/PEConceptComprehension';
import PEEmentorObject from '../main/pages/instance/views/templates/practicalexercise/PEEmentorObject';
import PEInformativeEvent from '../main/pages/instance/views/templates/practicalexercise/PEInformativeEvent';
import PEDecisionEvent from '../main/pages/instance/views/templates/practicalexercise/PEDecisionEvent';
import PEObservationEvent from '../main/pages/instance/views/templates/practicalexercise/PEObservationEvent';
import PEDialogInteraction from '../main/pages/instance/views/templates/practicalexercise/PEDialogInteraction';
import PEFaceToFaceInteraction from '../main/pages/instance/views/templates/practicalexercise/PEFaceToFaceInteraction';
import PEPhoneCallInteraction from '../main/pages/instance/views/templates/practicalexercise/PEPhoneCallInteraction';
import PECompletionEvent from '../main/pages/instance/views/templates/practicalexercise/PECompletionEvent';
import ConstructedResponse from '../main/pages/instance/views/templates/practicalexercise/ConstructedResponse';
import PEConstructedDraftReport from '../main/pages/instance/views/templates/practicalexercise/PEConstructedDraftReport';
import PECapstoneHypothesisResponse from '../main/pages/instance/views/templates/practicalexercise/PECapstoneHypothesisResponse';
import PECapstonePresentationBrief from '../main/pages/instance/views/templates/practicalexercise/PECapstonePresentationBrief';
import PECapstoneSpokenResponse from '../main/pages/instance/views/templates/practicalexercise/PECapstoneSpokenResponse';
import PECapstoneWhitePaper from '../main/pages/instance/views/templates/practicalexercise/PECapstoneWhitePaper';
import NoteCards from '../main/pages/instance/views/templates/practicalexercise/NoteCards';
import PECapstoneOpEdPaper from '../main/pages/instance/views/templates/practicalexercise/PECapstoneOpEdPaper';
import FPECapstone from '../main/pages/instance/views/templates/practicalexercise/FPECapstone';
import PEDebrief from '../main/pages/instance/views/templates/practicalexercise/PEDebrief';
// Assessment Templates
import AssessmentIntroduction from '../main/pages/instance/views/templates/assessment/AssessmentIntroduction';
import AssessmentListeningMC from '../main/pages/instance/views/templates/assessment/AssessmentListeningMC';
import AssessmentReadingMC from '../main/pages/instance/views/templates/assessment/AssessmentReadingMC';
import AssessmentSummary from '../main/pages/instance/views/templates/assessment/AssessmentSummary';
// Introduction Templates
import IntroCarousel from '../main/pages/instance/views/templates/introduction/IntroCarousel';
import TutorialVideo from '../main/pages/instance/views/templates/introduction/TutorialVideo';
import IntroSummary from '../main/pages/instance/views/templates/introduction/IntroSummary';

// Create styles
const styles = {
  question: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    width: '100%',
    marginBottom: '0.25in'
    // paddingLeft: "0.5in",
    // paddingRight: "0.5in",
  },
  dialogLabel: {
    textAlign: 'left',
    width: '100%',
    paddingLeft: '0.5in',
    paddingRight: '0.5in',
    fontSize: '12pt',
    color: '#666',
    marginBottom: '0.125in'
  },
  break: {
    width: '85%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '0.25in',
    borderBottom: '2px solid #ccc',
    pageBreakAfter: 'always'
  }
};

// Create Document Component
export const Storyboard = ({ lesson, templates }) => {
  let templatesUsed = [];

  const getDIR = (label = null) => {
    if (label === null) return;

    if (label.split('-')[0] === 'AD') return 'rtl';
    else return 'ltr';
  };

  const dir = getDIR(lesson.label);

  const getTemplate = (templateId, page, index) => {
    const foundTemplate = templates.find(
      (template) => template.id === templateId
    );

    if (!foundTemplate) {
      return <div>Could not find {templateId}</div>;
    }

    if (!templatesUsed.some((template) => template.id === foundTemplate.id)) {
      templatesUsed.push(foundTemplate);
    }

    const templateLabel = foundTemplate.label;
    // write a switch statement to return the correct template
    switch (templateLabel) {
      // Lesson Templates
      case 'TMP-L-001':
        return (
          <IntroductionVideo
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-002':
        return (
          <Objectives
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-003':
        return (
          <SceneSetter
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-004':
        return (
          <TerminologyReview
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-005':
        return (
          <Reading
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-006':
        return (
          <Listening
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-007':
        return (
          <MultipleChoice
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-008':
        return (
          <ConceptCategorizing
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-009':
        return (
          <ErrorIdentification
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-010':
        return (
          <SummaryEvaluation
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-011':
        return (
          <LinguisticEvaluation
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-012':
        return (
          <RegisterAnalysis
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-013':
        return (
          <LessonSummary
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-014':
        return (
          <ModuleSummary
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-L-015':
        return (
          <Enrichment
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      // Practical Exercise Templates
      case 'TMP-PE-001':
        return (
          <PETransition
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-002':
        return (
          <PEMissionSelection
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-003':
        return (
          <PEBrief
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-004':
        return (
          <PEEnvironment
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-005':
        return (
          <FPEEnvironmentHome
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-006':
        return (
          <FPEEnvironmentPath
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-007':
        return (
          <PEReading
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-008':
        return (
          <PEInteractiveListening
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-009':
        return (
          <PEReferenceReading
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-010':
        return (
          <PEReferenceListening
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-011':
        return (
          <PEMultipleChoice
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-012':
        return (
          <PEConceptComprehension
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-013':
        return (
          <PEEmentorObject
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-014':
        return (
          <PEInformativeEvent
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-015':
        return (
          <PEDecisionEvent
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-016':
        return (
          <PEObservationEvent
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-017':
        return (
          <PEDialogInteraction
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-018':
        return (
          <PEPhoneCallInteraction
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-019':
        return (
          <PEFaceToFaceInteraction
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-020':
        return (
          <PECompletionEvent
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-021':
        return (
          <ConstructedResponse
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-022':
        return (
          <PEConstructedDraftReport
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-023':
        return (
          <PECapstoneHypothesisResponse
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-024':
        return (
          <PECapstonePresentationBrief
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-025':
        return (
          <PECapstoneSpokenResponse
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-026':
        return (
          <PECapstoneWhitePaper
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-027':
        return (
          <NoteCards
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-028':
        return (
          <PECapstoneOpEdPaper
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-029':
        return (
          <FPECapstone
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-PE-030':
        return (
          <PEDebrief
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      // Assessment Templates
      case 'TMP-A-001':
        return (
          <AssessmentIntroduction
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-A-002':
        return (
          <AssessmentReadingMC
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-A-003':
        return (
          <AssessmentListeningMC
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-A-004':
        return (
          <AssessmentSummary
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      // Introduction Templates
      case 'TMP-I-001':
        return (
          <IntroCarousel
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-I-002':
        return (
          <TutorialVideo
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      case 'TMP-I-003':
        return (
          <IntroSummary
            data={page.content}
            dir={dir}
            ins={foundTemplate.instructions}
            course={lesson.course.id}
          />
        );
      default:
        return (
          <div>
            <p>No page id found</p>
          </div>
        );
    }
  };

  const displayAppendix = (arr) => {
    return (
      <>
        <Typography className="text-18 font-semibold px-16 mb-16">
          Appendix: Templates
        </Typography>
        <Grid container spacing={2} className="w-full mb-16 px-16">
          {arr.map((template, tIndex) => (
            <Grid item xs={3} key={`template_summary_${tIndex}`}>
              <Typography>{template.title}</Typography>
            </Grid>
          ))}
        </Grid>
      </>
    );
  };

  return (
    <div className="bg-white w-full p-24 print:p-0">
      {lesson.sections.map((section, sIndex) => (
        <div key={`section-${sIndex}`}>
          {section.pages.map((page, index) => (
            <div
              key={`section-${sIndex}-page-${index}`}
              className="page"
              style={{
                minHeight: '11in',
                padding: '0.5in',
                margin: '0 auto',
                border: '1px #D3D3D3 solid',
                borderRadius: '4px',
                background: 'white',
                pageBreakAfter: 'always'
              }}
            >
              <Header
                course={{
                  label: lesson.course.label,
                  title: lesson.course.title
                }}
                lesson={{
                  label: lesson.label,
                  title: lesson.title
                }}
                section={{
                  label: section.label,
                  title: section.title
                }}
                page={{
                  title: page.title,
                  pageNumber: page.screen,
                  prevPage: page.back,
                  nextPage: page.next
                }}
              />
              {getTemplate(page.template.id, page, index)}
            </div>
          ))}
        </div>
      ))}

      {/* displayAppendix(templatesUsed) */}
    </div>
  );
};
